import {Directive, HostBinding, Input} from '@angular/core';

@Directive({selector: '[axNavbarItem]'})
export class NavbarItemDirective {
  @HostBinding('class.ax-navbar-item') _class = true;
  @Input() @HostBinding('class.ax-navbar-item-active') active = false;
}
